const FETCH_MY_STORIES = 'studio/myPage/FETCH_MY_STORIES';

const FETCH_MY_COMMUNITIES = 'studio/myPage/FETCH_MY_COMMUNITIES';

const DELTE_COMMUNITY_POST = 'studio/myPage/DELTE_COMMUNITY_POST';

const RESET = 'studio/myPage/RESET';

export default {
  FETCH_MY_STORIES,
  FETCH_MY_COMMUNITIES,
  DELTE_COMMUNITY_POST,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/myPage/types.js